import React from 'react'
import { attributesToProps, Element } from 'html-react-parser'
import { IconClient } from './icon-parser-effects'
import type { IconName } from '@dustin-web/microsite-components/src/icon'
import type { Parser } from '.'

export const iconParser: Parser = node => {
  if (node.type !== 'tag' || node.name !== 'svg') {
    return
  }

  const icon = node.children.find(n => {
    const el = n as Element
    return (
      el.type == 'tag' &&
      el.name == 'use' &&
      // Both xlink:href and href are used so we need to check both
      (Object.prototype.hasOwnProperty.call(el.attribs, 'xlink:href') ||
        Object.prototype.hasOwnProperty.call(el.attribs, 'href'))
    )
  }) as Element

  if (!icon) {
    return
  }

  let attribute: string

  if (Object.prototype.hasOwnProperty.call(icon.attribs, 'xlink:href')) {
    attribute = 'xlink:href'
  } else {
    attribute = 'href'
  }

  // pick out icon name from 'attribute="#i-{iconname}"'
  const iconMatch = icon.attribs[attribute]?.match(/^#i-(.*)/)

  if (iconMatch) {
    const props = attributesToProps(node.attribs)
    const iconName = iconMatch[1] as IconName

    return <IconClient name={iconName} {...props} />
  }
}
